import styled from "styled-components";

export const Container = styled.div`
  align-items: center;
  background: #ffffff;
  box-shadow: 0px 5px 20px rgba(231, 231, 234, 0.62);
  border-radius: 8px;
  display: flex;
  height: 96px;
  justify-content: space-between;
  margin-bottom: 8px;
  width: 100%;
`;

export const Amount = styled.label`
  color: #88b13b;
  flex: none;
  flex-grow: 0;
  font-family: Montserrat;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 18px;
  order: 1;
`;

export const Code = styled.label`
  color: #002e6c;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 600;
  flex: none;
  flex-grow: 0;
  font-size: 14px;
  line-height: 18px;
  order: 0;
`;

export const Name = styled.label`
  color: #000000;
  font-family: Montserrat;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  flex-grow: 0;
  flex: none;
  line-height: 18px;
  order: 1;
  width: 29rem;
`;
